import { useState, useEffect } from 'react';
import {
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
} from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { closeEnmascararPaqueteAction } from "../../../ducks/proveedorTerrestreDuck";
import { FConfigurarMayoristaStyle } from './styles';
import { ToastMessage } from '../../../global/ToastMessage';
import { DialogMessage } from '../../../global/DialogMessage';
import { FormatoFechaIso } from '../../../utils/FormatFecha';
import ModalBase from "../../../global/ModalBase";
import HeaderModal from "../../../global/headerModal";
import useCatalogos from "../../../hooks/useCatalogos";
import SeccionDestacarPaquete from './SeccionDestacarPaquete';
import SeccionRegiones from './SeccionRegiones';
import { catGrupoPaqueteProveedor } from '../../../constant/catGrupoPaqueteProveedor';
import useApi from '../../../hooks/useAPI';
import { 
  actualizaPaqueteMayoristaAction, 
  crearPaqueteMayoritaAction, 
  obetenerPaqueteMayoristaListaDetalle, 
  obtenerListaPreciosPaqueteMayoristaAction, 
  obtenerPaqueteMayoristaAction 
} from '../../../ducks/proveedorMayoristaDuck';
import { offLoadAction, onLoadAnction } from '../../../ducks/loadDuck';
import TablaPreciosAPI from './TablaPreciosAPI';

const FConfigurarMayorista = () => {
  const dispatch = useDispatch();
  const classes = FConfigurarMayoristaStyle();
  const regiones = useCatalogos("Region");
  const catalogoUtilidades = useCatalogos("Utility");
  const catalogoGrupoPaquete = useApi(`Supplier/groupPack/${catGrupoPaqueteProveedor.ID_PROVEEDOR_GRAN_TOUR}`);
  const { openEnmascararPaquete, paqueteSelect } = useSelector(store => store.proveedorTerrestre);
  
  const [listaPrecios, setListaPrecios] = useState([]);
  const [tabActual, setTabActual] = useState(0);
  const [datosPorRegion, setDatosPorRegion] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');
  const [tieneEstrella, setTieneEstrella] = useState(false);
  const [sobreDescuento, setSobreDescuento] = useState(0);
  const [fechaLimiteDescuento, setFechaLimiteDescuento] = useState(null);
  const [clavePaquete, setClavePaquete] = useState("");
  const [mayoristaSelect, setMayoristaSelect] = useState(null);
  const [errorPrecios, setErrorPrecios] = useState(false);
   
  const getRegionesPaquete = () => {
    if (!paqueteSelect?.lPaqueteCicuito) return [];
    
    const regionesUnicas = new Map();

    paqueteSelect.lPaqueteCicuito.forEach(circuito => {
      circuito.LPaqueteCircuitoRegion?.forEach(regionConfig => {
        const region = regionConfig.CatRegion;
        regionesUnicas.set(region.IdCatRegion, region);
      });
    });
  
    return Array.from(regionesUnicas.values());
  };

  useEffect(() => {
    setDatosPorRegion([]);
    setMayoristaSelect(null);
    setCategoriaSeleccionada(0);
    setClavePaquete("");
    setTieneEstrella(false);
    setSobreDescuento(0);
    setFechaLimiteDescuento(null);

    const fecthData = async () => {
      if (paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista) {
        try {
          const response = await dispatch(obtenerPaqueteMayoristaAction({ IdPaqueteMayorista: paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista }));

          setMayoristaSelect(response);
          setCategoriaSeleccionada(response.grupoPaqueteProveedor.IdProveedorGrupoPaquete);
          setClavePaquete(response.ClavePaquete);
          setTieneEstrella(response.PaqueteMayoristaOferta?.IdPaqueteMayoristaOferta > 0 );
          setSobreDescuento(response.PaqueteMayoristaOferta?.Porcentaje || 0);
          setFechaLimiteDescuento(response.PaqueteMayoristaOferta?.FechaFin || null);

          const regionesPaquete = getRegionesPaquete();

          const nuevasRegiones = regionesPaquete.map(region => {
            const utilidad = response.lPaqueteMayoristaUtilidad.find(
              u => u.CatRegion?.IdCatRegion === region.IdCatRegion
            );
            
            return {
              idRegion: region.IdCatRegion,
              nombreRegion: region.Descripcion,
              activo: !!utilidad,
              datos: {
                nombre: utilidad?.Nombre || paqueteSelect.Nombre,
                descripcion: utilidad?.Descripcion || ''
              },
              utilidad: utilidad?.CatUtilidad?.IdCatUtilidad || 1
            };
          });

          if(regionesPaquete.length > 0){
            const globalUtilidad = response.lPaqueteMayoristaUtilidad.find(
              u => u.IdCatRegion === null
            );
            
            nuevasRegiones.push({
              idRegion: 0,
              nombreRegion: 'Global',
              activo: !!globalUtilidad,
              datos: {
                nombre: globalUtilidad?.Nombre || paqueteSelect.Nombre,
                descripcion: globalUtilidad?.Descripcion || ''
              },
              utilidad: globalUtilidad?.CatUtilidad?.IdCatUtilidad || 1
            });
          }
          setDatosPorRegion(nuevasRegiones);

        } catch (error) {
          console.error('Error al cargar datos:', error);
        }
      } else {
        const regionesPaquete = getRegionesPaquete();
      
        const nuevasRegiones = regionesPaquete.map(region => ({
          idRegion: region.IdCatRegion,
          nombreRegion: region.Descripcion,
          activo: false,
          datos: {
            nombre: paqueteSelect?.Nombre || '',
            descripcion: ''
          },
          utilidad: 1 // Valor por defecto
        }));

        // Agregar región Global si hay regiones
        if (regionesPaquete.length > 0) {
          nuevasRegiones.push({
            idRegion: 0,
            nombreRegion: 'Global',
            activo: false,
            datos: {
              nombre: paqueteSelect?.Nombre || '',
              descripcion: ''
            },
            utilidad: 1
          });
        }

        setDatosPorRegion(nuevasRegiones);
      }
    }

    fecthData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista, regiones])

  useEffect(() => {
    const fetchPrecios = async () => {
      try {
        // No hacer petición si no hay configuración de mayorista
        if (!mayoristaSelect?.IdPaqueteMayorista) return;

        const precios = await dispatch(
          obtenerListaPreciosPaqueteMayoristaAction({
            IdPaqueteMayorista: mayoristaSelect.IdPaqueteMayorista
          })
        );

        // Manejar respuesta vacía o inválida
        if (!precios || !Array.isArray(precios) || precios.length === 0) {
          setListaPrecios([]);
          setErrorPrecios('No se encontraron precios configurados');
        } else {
          setListaPrecios(precios);
          setErrorPrecios(null);
        }
      } catch (error) {
        setErrorPrecios('Error al cargar precios');
        console.error('Error:', error);
      }
    }

    fetchPrecios();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mayoristaSelect]);


  const handleChangeTab = (event, newValue) => {
    setTabActual(newValue);
  };

  const handleToggleRegion = (index) => {
    const nuevosDatos = [...datosPorRegion];
    const region = nuevosDatos[index];
    
    // Si es Global
    if (region.idRegion === 0) {
      region.activo = !region.activo;
      // Si activamos Global, desactivamos todas las demás
      if (region.activo) {
        nuevosDatos.forEach(r => {
          if (r.idRegion !== 0) r.activo = false;
        });
      }
    } 
    // Si es región específica
    else {
      region.activo = !region.activo;
      // Si activamos una región, desactivamos Global
      if (region.activo) {
        const globalIndex = nuevosDatos.findIndex(r => r.idRegion === 0);
        nuevosDatos[globalIndex].activo = false;
      }
    }
  
    setDatosPorRegion(nuevosDatos);
  };

  const handleChangeDatos = (index, field, value) => {
    const nuevosDatos = [...datosPorRegion];
    nuevosDatos[index].datos[field] = value;
    setDatosPorRegion(nuevosDatos);
  };

  const handleChangeUtilidad = (index, value) => {
    const nuevosDatos = [...datosPorRegion];
    nuevosDatos[index].utilidad = value;
    setDatosPorRegion(nuevosDatos);
  };
  
  const handleClose = () => {
    dispatch(closeEnmascararPaqueteAction());
    setCategoriaSeleccionada(0);
    setClavePaquete("");
    setTieneEstrella(false);
    setSobreDescuento(0);
    setFechaLimiteDescuento(null);
    setMayoristaSelect(null);
  };

  const handleGuardar = () => {
    const esActualizacion = !!mayoristaSelect?.IdPaqueteMayorista;
    const regionesSeleccionadas = datosPorRegion.filter(region => region.activo);
    const esGlobal = regionesSeleccionadas.some(region => region.idRegion === 0);

    const regionesDisponibles = getRegionesPaquete();
    
    if (regionesDisponibles.length === 0) {
      ToastMessage.fire({
        icon: 'error',
        title: 'No se pueden configurar precios sin regiones en los circuitos'
      });
      return;
    }

    if (!paqueteSelect?.IdPaqueteProveedorTerrestre) {
      ToastMessage.fire({ icon: 'error', title: 'No se encontró el paquete base' });
      return;
    }
    
    // Validaciones (mantener las mismas que ya tienes)
    if (tieneEstrella && (!fechaLimiteDescuento || new Date(fechaLimiteDescuento) < new Date())) {
      ToastMessage.fire({ icon: 'error', title: 'La fecha límite debe ser futura' });
      return;
    }
    
    if (regionesSeleccionadas.length === 0) {
      ToastMessage.fire({ icon: 'warning', title: 'Debes seleccionar al menos una región' });
      return;
    }

    if (!categoriaSeleccionada) {
      ToastMessage.fire({ icon: 'warning', title: 'Debes seleccionar una categoría' });
      return;
    }

    if (tieneEstrella && (sobreDescuento <= 0 || sobreDescuento > 50)) {
      ToastMessage.fire({ icon: 'error', title: 'El sobre-descuento debe estar entre 1% y 50%' });
      return;
    }

    DialogMessage.fire({
      title: esActualizacion ? '¿Confirmar actualización?' : '¿Confirmar configuración?',
      html: generarContenidoConfirmacion(esActualizacion),
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Guardar configuración',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      width: '700px',
      customClass: {
        confirmButton: `swal-confirm-button-${esActualizacion ? 'update' : 'create'}`
      }
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(onLoadAnction({ message: "Guardando configuración..." }))
        // Obtener la configuración de Global si está seleccionada
        const configuracionGlobal = datosPorRegion.find(region => region.idRegion === 0);
          
        // Determinar las regiones a guardar
        let regionesAGuardar = [];
        
        if (esGlobal) {
          // Si es Global, obtener todas las regiones excepto Global (idRegion !== 0)
          regionesAGuardar = datosPorRegion
            .filter(region => region.idRegion !== 0)
            .map(region => ({
              ...configuracionGlobal,
              idRegion: region.idRegion,
              nombreRegion: region.nombreRegion
            }));
        } else {
          // Si son regiones específicas, usar las seleccionadas
          regionesAGuardar = [...regionesSeleccionadas];
        }

        // Nueva estructura de datos según requerimiento
        const datosEnmascarados = {
          ...(esActualizacion && { 
            IdPaqueteMayorista: mayoristaSelect.IdPaqueteMayorista,
            Estatus: mayoristaSelect.Estatus
          }),
          IdPaqueteProveedorTerrestre: paqueteSelect.IdPaqueteProveedorTerrestre,
          IdProveedorGrupoPaquete: parseInt(categoriaSeleccionada),
          IdMoneda: paqueteSelect.Moneda.id_moneda,
          ClavePaquete: clavePaquete,
          Nombre: paqueteSelect.Nombre,
          PrecioPublico: paqueteSelect.PrecioNeto, // O el precio público si es diferente
          TipoCambioPrevisto: 1, // Asumiendo 1 como valor por defecto, ajustar según necesidad
          PaqueteMayoristaOferta: tieneEstrella ? {
            Porcentaje: parseFloat(sobreDescuento),
            FechaFin: FormatoFechaIso({date: fechaLimiteDescuento, formato: "yyyy-MM-dd"})
          } : null,
          lPaqueteMayoristaUtilidad: regionesAGuardar.map(region => {
            const utilidadExistente = mayoristaSelect?.lPaqueteMayoristaUtilidad?.find(
              u => u.IdCatRegion === (region.idRegion === 0 ? null : region.idRegion)
            );
            
            return {
              IdPaqueteMayorista: utilidadExistente?.IdPaqueteMayorista || 0,
              IdCatUtilidad: region.utilidad,
              IdCatRegion: region.idRegion === 0 ? null : region.idRegion,
              Nombre: region.datos.nombre,
              Descripcion: region.datos.descripcion
            };
          })
        };
        
        if(esActualizacion) {
          dispatch(actualizaPaqueteMayoristaAction(datosEnmascarados))
            .then(response => {
              if (response === 1) {
                ToastMessage.fire({
                  icon: 'success',
                  title: 'Configuración guardada correctamente'
                });
                dispatch(obetenerPaqueteMayoristaListaDetalle())
                handleClose()
              } else {
                ToastMessage.fire({
                  icon: 'error',
                  title: 'Error al guardar la configuración'
                });
              }
            })
            .catch(error => {
              ToastMessage.fire({
                icon: 'error',
                title: 'Error al guardar la configuración'
              });
              console.error('Error:', error);
            })
            .finally(() => {
              dispatch(offLoadAction())
            })
        } else {
          dispatch(crearPaqueteMayoritaAction(datosEnmascarados))
            .then(response => {
              if (typeof response === 'number') {
                ToastMessage.fire({
                  icon: 'success',
                  title: 'Configuración guardada correctamente'
                });
                dispatch(obetenerPaqueteMayoristaListaDetalle())
                handleClose()
              } else {
                ToastMessage.fire({
                  icon: 'error',
                  title: 'Error al guardar la configuración'
                });
              }
            })
            .catch(error => {
              ToastMessage.fire({
                icon: 'error',
                title: 'Error al guardar la configuración'
              });
              console.error('Error:', error);
            })
            .finally(() => {
              dispatch(offLoadAction())
            })
        }
      }
    });
  };

  const mostrarPestanias = datosPorRegion.filter(r => r.activo).length > 1;

  const renderTablaPrecios = (region) => {
    if (errorPrecios) {
      return (
        <Box p={4} textAlign="center">
          <Typography variant="h6" color="error">
            {errorPrecios}
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            Por favor, verifique la configuración de utilidades para esta región.
          </Typography>
        </Box>
      );
    }
    
    return (
      <TablaPreciosAPI
        listaPrecios={listaPrecios} 
        regionActiva={region}
        error={errorPrecios}
      />
    );
  };

  const generarContenidoConfirmacion = (esActualizacion) => {
    const regionesActivas = datosPorRegion.filter(region => region.activo);
    const categoriaNombre = catalogoGrupoPaquete.find(c => c.IdProveedorGrupoPaquete === categoriaSeleccionada)?.grupoPaquete?.Descripcion || 'Sin categoría';
  
    return `
    <div style="max-height: 400px; overflow-y: auto;">
      <h3 style="margin-bottom: 0.5rem; color: ${esActualizacion ? '#2e7d32' : '#1976d2'};">
        ${esActualizacion ? 'Actualizar Configuración' : 'Crear Nueva Configuración'}
      </h3>
      <p style="color: #666; margin-bottom: 1.5rem;">
        ${esActualizacion 
          ? 'Estás a punto de actualizar la configuración del paquete mayorista.' 
          : 'Estás a punto de crear una nueva configuración de paquete mayorista.'}
      </p>
      
      <div style="background: #f5f5f5; padding: 1rem; border-radius: 4px; margin-bottom: 1.5rem;">
        <div style="display: flex; justify-content: space-between; font-size: 1.1rem; margin-bottom: 0.5rem;">
          <strong>Categoría:</strong>
          <span>${categoriaNombre}</span>
        </div>
        <div style="display: flex; justify-content: space-between; font-size: 1.1rem; margin-bottom: 0.5rem;">
          <strong>Clave Paquete:</strong>
          <span>${clavePaquete || 'No especificada'}</span>
        </div>
  
        ${tieneEstrella ? `
          <div style="display: flex; justify-content: space-between; font-size: 1.1rem; margin-bottom: 0.5rem;">
            <strong>Descuento destacado:</strong>
            <span>${sobreDescuento}% (hasta ${new Date(fechaLimiteDescuento).toLocaleDateString()})</span>
          </div>
        ` : ''}
      </div>
      
      <h4 style="margin: 1rem 0 0.5rem 0; color: #555;">Configuración por Región:</h4>
      <ul class="custom-list" style="padding: 0; list-style: none;">
        ${regionesActivas.map(region => {
          const utilidadObj = catalogoUtilidades.find(u => u.IdCatUtilidad === region.utilidad);
          const porcentajeUtilidad = utilidadObj?.Porcentaje || 0;
  
          return `
            <li style="margin-bottom: 1rem; border-bottom: 1px solid #eee; padding-bottom: 1rem;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <strong style="font-size: 1.1rem; color: #1976d2;">
                  ${region.nombreRegion}
                </strong>
                <span style="background: #e3f2fd; color: #1976d2; padding: 0.25rem 0.5rem; border-radius: 4px; font-weight: bold;">
                  Utilidad: ${porcentajeUtilidad}%
                </span>
              </div>
              
              <div style="margin-top: 0.5rem;">
                <div><strong>Nombre comercial:</strong> ${region.datos.nombre}</div>
                ${region.datos.descripcion ? `<div><strong>Descripción:</strong> ${region.datos.descripcion}</div>` : ''}
              </div>
            </li>
          `;
        }).join('')}
      </ul>
    </div>
    `;
  };

  if (!paqueteSelect) return null;

  const esActualizacion = !!mayoristaSelect?.IdPaqueteMayorista;

  return (
    <ModalBase classes={classes} open={openEnmascararPaquete} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={`${esActualizacion ? 'Actualizar' : 'Crear'} Paquete Mayorista: ${paqueteSelect?.Nombre}`}
      />

      <DialogContent dividers style={{ height: "70vh", maxHeight: '600px', overflowY: 'auto'}}>
        {/* Sección de Categoría */}
        <Grid container spacing={2} style={{ marginBottom: '20px', padding: '16px', border: '1px solid #eee', borderRadius: '8px' }}>
          
          <Grid item xs={12}>
            <Typography variant="h6" style={{ marginBottom: '16px' }}>Información General</Typography>
          </Grid>
          
          {/* Campo para la clave del paquete */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Clave del paquete"
              value={clavePaquete}
              onChange={(e) => setClavePaquete(e.target.value)}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          
          {/* Selector de categoría */}
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="categoria-label">Categoría del paquete</InputLabel>
              <Select
                labelId="categoria-label"
                value={categoriaSeleccionada}
                onChange={(e) => {
                  setCategoriaSeleccionada(e.target.value)
                }}
                label="Categoría del paquete"
              >
                {catalogoGrupoPaquete?.map((categoria) => (
                  <MenuItem 
                    key={categoria?.IdProveedorGrupoPaquete} 
                    value={categoria?.IdProveedorGrupoPaquete}
                  >
                    {categoria?.grupoPaquete?.Descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Sección de Destacar Paquete */}
        <SeccionDestacarPaquete
          tieneEstrella={tieneEstrella}
          sobreDescuento={sobreDescuento}
          fechaLimiteDescuento={fechaLimiteDescuento}
          onToggleEstrella={() => setTieneEstrella(!tieneEstrella)}
          onSobreDescuentoChange={(e) => setSobreDescuento(e.target.value)}
          onFechaDescuentoChange={(e) => setFechaLimiteDescuento(e.target.value)}
        />

        {/* Sección de Regiones */}
        <SeccionRegiones
          regiones={regiones}
          datosPorRegion={datosPorRegion}
          tabActual={tabActual}
          mostrarPestanias={mostrarPestanias}
          onToggleRegion={handleToggleRegion}
          onChangeTab={handleChangeTab}
          onChangeDatos={handleChangeDatos}
          onChangeUtilidad={(index, value) => handleChangeUtilidad(index, Number(value))}
          renderTablaPrecios={renderTablaPrecios}
          catalogoUtilidades={catalogoUtilidades}
        />
      </DialogContent>
      
      <DialogActions style={{padding: "0.75rem"}}>
        <Button variant='outlined' onClick={handleClose} style={{ marginRight: "1rem" }}>
          Cancelar
        </Button>
        <Button 
          onClick={handleGuardar} 
          color={esActualizacion ? "secondary" : "primary"}
          variant="contained"
          disabled={!datosPorRegion.some(region => region.activo) || !categoriaSeleccionada}
        >
          {esActualizacion ? 'Actualizar Configuración' : 'Guardar Configuración'}
        </Button>
      </DialogActions>
    </ModalBase>
  );
};

export default FConfigurarMayorista